export const AUTH_URL_PART = 'auth';
export const OAUTH_URL_PART = 'oauth';
export const PASSWORD_RECOVERY = 'password-recovery'
